import { colors, GoodSansB2, QueensH2 } from '@components/shared'
import * as React from 'react'
import { Col, Container, Row } from 'react-awesome-styled-grid'
import styled from 'styled-components'
type PropsType = {
  takeMeThere: (id: string) => void
}

export default function WriteForUsSubMenu (_props: PropsType): React.ReactNode {
  return (
    <Container>
      <Row justify='center'>
        <Col align='center'>
          <Header>
            Write for Dipsea.
          </Header>
          <Description>
            Dipsea is on the hunt for talented writers to expand our world of immersive audiobooks and audio dramas. We're seeking storytellers with backgrounds in romance, fiction, television, copywriting, fanfiction, and theater. Our ideal candidates can seamlessly blend with our signature style while breathing fresh life into our beloved characters and fictional universes. All writing opportunities are paid, and we regularly collaborate with our network of freelance writers. Ready to dive in? Apply by crafting a new chapter for one of our popular Dipsea audiobooks. If your sample captivates us, we'll offer you $50 for a round of revisions, with an additional $150 if we move forward with recording and production. Join us in creating audio experiences that resonate!
          </Description>
        </Col>
      </Row>
    </Container>
  )
}

const Header = styled.h1<any>`
  ${QueensH2};
  text-align: center;
  margin: 3.5rem 0 1.2rem;
  color: ${colors.sand};
`
const Description = styled.p<any>`
  ${GoodSansB2};
  text-align: center;
  margin-bottom: 2.2rem;
  color: ${colors.sand};
  max-width: 950px;
`
